import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSubway(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 5.5A.75.75 0 0 1 9 4.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75M8.25 16.617a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M15.75 16.617a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.75 2.25A2.75 2.75 0 0 0 4 5v11.594a2.75 2.75 0 0 0 2.49 2.738l-1.77 1.77a.75.75 0 1 0 1.06 1.061l.593-.593h11.254l.593.593a.75.75 0 1 0 1.06-1.06l-1.77-1.771A2.75 2.75 0 0 0 20 16.594V5a2.75 2.75 0 0 0-2.75-2.75zm8.78 17.094H8.47a.75.75 0 0 1-.19.32l-.407.406h8.254l-.407-.407a.75.75 0 0 1-.19-.32M5.5 5c0-.69.56-1.25 1.25-1.25h10.5c.69 0 1.25.56 1.25 1.25v6.25h-13zm0 7.75h13v3.844c0 .69-.56 1.25-1.25 1.25H6.75c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcSubway = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSubway));

export { IcSubway as I };
